module.exports = __webpack_public_path__ + "static/media/so.fd9745c3.svg";